import React, { forwardRef, useCallback } from "react";
import { List } from "react-window";

const LISTBOX_PADDING = 8;
export const ITEM_SIZE = 50;

const VirtualizedListbox = forwardRef(function VirtualizedListbox(props, ref) {
  const { children, ...other } = props;
  const items = React.Children.toArray(children).filter(v => v.props.option.visible);
  const getItemSize = () => ITEM_SIZE;
  const HEIGHT = Math.min(8 * ITEM_SIZE, items.length * ITEM_SIZE + 2 * LISTBOX_PADDING);

  const renderRow = useCallback(
    ({ index, style }) => {
      return (
        <div style={{ ...style, paddingLeft: LISTBOX_PADDING, paddingRight: LISTBOX_PADDING }}>
          {items[index]}
        </div>
      );
    },
    [items]
  );

  return (
    <div ref={ref} {...other}>
      <List
        style={{ height: HEIGHT, width: "100%" }}
        rowHeight={getItemSize()}
        rowCount={items.length}
        overscanCount={5}
        rowComponent={renderRow}
        rowProps={{}}
      />
    </div>
  );
});

export default VirtualizedListbox; 